import ServiceManager from '../../service/ServiceManager';
import { data } from '../../constants/Constants';
import { getDevice } from './utilApi';
export function EliminarDispositivo(Codigo, CodigoDealer, CorreoElectronico, Id, VKorg, Poblacion, Canal, Sector) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/EliminarDispositivo";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.DispositivoDealer': Codigo, // DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronico,
        'dto.DispositivoId': Id,
        'dto.VKorg': VKorg,
        'dto.Poblacion': Poblacion,
        'dto.Canal': Canal,
        'dto.Sector': Sector,
        'dto.Sistema': data.Sistema
    };
    console.log("EliminarDispositivo====>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function getData(CodigoDealer, CorreoElectronico, VKorg, Poblacion, Canal, Sector, Linea) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/perfil";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronico,
        'dto.VKorg': VKorg,
        'dto.Poblacion': Poblacion,
        'dto.Canal': Canal,
        'dto.Linea': Linea,
        'dto.Sector': Sector,
        'dto.Sistema': data.Sistema
    };
    console.log("getData params.data====>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function setLocal(CodigoDealer, CorreoElectronico, Alias, LocalId, Canal, Sector) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ActualizaLocal";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronico,
        'dto.Alias': Alias,
        'dto.LocalId': LocalId,
        'dto.Canal': Canal,
        'dto.Sector': Sector,
        'dto.Sistema': data.Sistema
    };
    console.log("SetLocal====>", params.data);
    return ServiceManager.prototype.Post(params);
}
export function ListarLocal(CodigoDealer, CorreoElectronico, Canal, Sector) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarLocal";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.CodigoNuevoDealer': CodigoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronico,
        'dto.Canal': Canal,
        'dto.Sector': Sector,
        'dto.Sistema': data.Sistema
    };
    console.log("ListarLocal====>", params.data);
    return ServiceManager.prototype.Post(params);
}